import LocadStaking from "../pages/LocadStaking"
import Staking from "../pages/Staking"
import Deposit from "../pages/Deposit"
import Llstaking from "../pages/Llstaking"
import BetaGame from "../pages/Game"
import BossWeaponMint from "../pages/BossWeaponMint"
import Wallet from "../pages/Wallet"
import Home from "../pages/Home"
import Marketplace from "../pages/Marketplace"
import AssetDetails from "../pages/AssetDetails"

const pageRoutes = [
  { path: "/", component: <Marketplace /> },
  { path: "/shop/:assetID", component: <AssetDetails /> },
  { path: "/shop", component: <Marketplace /> },
  { path: "/locad-staking/staking", component: <Marketplace /> },
  { path: "/locad-staking/deposit", component: <Marketplace /> },
  { path: "/locad-staking/llstaking", component: <Marketplace /> },
  { path: "/locad-staking", component: <Marketplace /> },
  { path: "/betagame", component: <BetaGame /> },
  { path: "/wallet", component: <Wallet /> },
  { path: "/bwminting", component: <BossWeaponMint /> },
  // { path: "*", element: <Navigate to="/" /> }
  // this route should be at the end of all other routes
  // { path: "*", exact: true, component: Pages404 },
]

export { pageRoutes }
